var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21.103 9h-18V7l9-4 9 4v2z",
    stroke: "currentColor",
    strokeWidth: 1.51,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.603 15.5v-4M19.602 11.5v4M9.603 11.5v4M14.602 11.5v4",
    stroke: "currentColor",
    strokeWidth: 1.51,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.103 18h18v3h-18v-3z",
    stroke: "currentColor",
    strokeWidth: 1.51,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgBank;